// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"92a668ce","453":"8f5830d1"}[chunkId] + ".chunk.js";
};